import React, {useEffect} from 'react'
import Navbar from '../components/Navbar'
import Landing from '../components/Landing'

function Login() {
    return (
        <div>
            <Navbar/>
            <Landing/>
            
        </div>
    )
}

export default Login
